const parallax = () => {

    gsap.utils.toArray(".parallax img").forEach((img) => {
        gsap.fromTo(
            img,
            { y: 0 },
            {
                y: -250,
                ease: "none",
                scrollTrigger: {
                    trigger: img.parentElement,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                }
            }
        );
    });
}

export default parallax;